import { translateLanguage } from 'components';
import { AddEditAppoinmentContent } from 'models';

export const MOMENT_DEFAULT_DATE = 'YYYY-MM-DD';

export const MOMENT_DEFAULT_DATE_WITH_TIME = 'YYYY-MM-DD HH:mm';


export const dafultDropdownState = {
  id: 0,
  title: '',
};

export const dafultTimeDropdownState = {
  startTime: '',
  endTime: '',
};

export const initialState = {
  id: 0,
  overNight: false,
  referralID: 0,
  procedureIds: [],
  // packageId: '',
  // membershipId: '',
  appointmentTypeId: 0,
  areaIds: [],
  anesthesia: '',
  anesthesiaType: '',
  notes: '',
  additionalNotes: '',
  concerns: '',
  goals: '',
  isWaitlisted: false,
  staffIds: [],
  patientID: 0,
  start_date: new Date(),
  end_date: new Date(),
  appointmentStatusType: '',
  patientName: '',
  eventLength: '',
  hourDate: '',
  isRecurring: false,
  procured: '',
  recType: '',
  procedureNames: '',
  procDetails: '',
  patientFullName: '',
  locationId: 0,
  uri: '',
  showAlertOnCancel: false,

  primaryPhone1: '',
  primaryEmailAddress: '',
  firstName: '',
  lastName: '',
  patientType: 'registeredPatient',
  sex: '',
  dateOfBirth: null,
  patientPhoneNumber: '',
  email: '',
  recurringStartDate: '',
  recurringEndDate: '',
  modifyTheWholeRecurringEvents: null,
  isAppointmentReminderMessage: false
};

export const leadInitialState = {
  id: 0,
  overNight: false,
  referralID: 0,
  procedureIds: [],
  // packageId: '',
  // membershipId:'',
  appointmentTypeId: 0,
  areaIds: [],
  anesthesia: '',
  anesthesiaType: '',
  notes: '',
  additionalNotes: '',
  concerns: '',
  goals: '',
  isWaitlisted: false,
  staffIds: [],
  patientID: 0,
  start_date: new Date(),
  end_date: new Date(),
  appointmentStatusType: '',
  patientName: '',
  eventLength: '',
  hourDate: '',
  isRecurring: false,
  procured: '',
  recType: '',
  procedureNames: '',
  procDetails: '',
  patientFullName: '',
  LocationId: 0,
  uri: '',
  showAlertOnCancel: false,
  primaryPhone1: '',
  primaryEmailAddress: '',
  locationId: 0,
  firstName: '',
  lastName: '',
  patientType: 'registeredPatient',
  sex: '',
  dateOfBirth: null,

  patientPhoneNumber: '',
  email: '',
};

export const patValidationBasedOnAppt = [
  'un-available',
  'reporting',
  'shadowing doctor',
  'repairs and maintenance',
  'training',
  'reserved for consults',
  'filming',
  'out of office',
  'meetings',
  'statutory holiday',
  'admin',
  'lunch break',
  'vacation',
  'day off',
];

export const checkApptFlag = (
  patValidationBasedOnAppt: any,
  appointment: any,
) => {
  const checkFlag = patValidationBasedOnAppt.some(
    (element: any) => element?.toLowerCase() === appointment?.toLowerCase(),
  );
  return !checkFlag;
};

export const initRecursiveDialogState = {
  clickedYes: false,
  clickedNo: false,
};

export const recursiveTypeRadio = [
  {
    id: `${AddEditAppoinmentContent.Daily}`,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Daily}`,
    ),
  },
  {
    id: `${AddEditAppoinmentContent.Weekly}`,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Weekly}`,
    ),
  },
  {
    id: `${AddEditAppoinmentContent.Monthly}`,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Monthly}`,
    ),
  },
  {
    id: `${AddEditAppoinmentContent.Yearly}`,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Yearly}`,
    ),
  },
];

export const anesthesiaRadioOptions = [
  {
    id: 0,
    label: translateLanguage(
      `AddEditAppointment.${[
        AddEditAppoinmentContent.None,
      ]}`,
    )
  },
  {
    id: 1,
    label:translateLanguage(
      `AddEditAppointment.${[
        AddEditAppoinmentContent.Local,
      ]}`,
    )
  },
  {
    id: 2,
    label:translateLanguage(
      `AddEditAppointment.${[
        AddEditAppoinmentContent.General,
      ]}`,
    )
  },
  {
    id: 3,
    label:translateLanguage(
      `AddEditAppointment.${[
        AddEditAppoinmentContent.EMLA,
      ]}`,
    )
  },
  {
    id: 4,
    label:translateLanguage(
      `AddEditAppointment.${[
        AddEditAppoinmentContent.ConsciousSedation,
      ]}`,
    )
  },
]

export const dayShortForm = [
  {
    id: 0,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Sun}`,
    ),
    day: 'SU',
  },
  {
    id: 1,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Mon}`,
    ),
    day: 'MO',
  },
  {
    id: 2,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Tue}`,
    ),
    day: 'TU',
  },
  {
    id: 3,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Wed}`,
    ),
    day: 'WE',
  },
  {
    id: 4,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Thu}`,
    ),
    day: 'TH',
  },
  {
    id: 5,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Fri}`,
    ),
    day: 'FR',
  },
  {
    id: 6,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Sat}`,
    ),
    day: 'SA',
  },
];

export const dayFullForm = [
  {
    id: 0,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Sunday}`,
    ),
    day: 'SU',
  },
  {
    id: 1,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Monday}`,
    ),
    day: 'MO',
  },
  {
    id: 2,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Tuesday}`,
    ),
    day: 'TU',
  },
  {
    id: 3,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Wednesday}`,
    ),
    day: 'WE',
  },
  {
    id: 4,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Thursday}`,
    ),
    day: 'TH',
  },
  {
    id: 5,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Friday}`,
    ),
    day: 'FR',
  },
  {
    id: 6,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.Saturday}`,
    ),
    day: 'SA',
  },
];

export const monthFullForm = [
  {
    id: 0,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.January}`,
    ),
  },
  {
    id: 1,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.February}`,
    ),
  },
  {
    id: 2,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.March}`,
    ),
  },
  {
    id: 3,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.April}`,
    ),
  },
  {
    id: 4,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.May}`,
    ),
  },
  {
    id: 5,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.June}`,
    ),
  },
  {
    id: 6,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.July}`,
    ),
  },
  {
    id: 7,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.August}`,
    ),
  },
  {
    id: 8,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.September}`,
    ),
  },
  {
    id: 9,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.October}`,
    ),
  },
  {
    id: 10,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.November}`,
    ),
  },
  {
    id: 11,
    label: translateLanguage(
      `AddEditAppointment.${AddEditAppoinmentContent.December}`,
    ),
  },
];

export const repeatAppointmentDefaultValues = (
  startDate: any,
  endDate: any,
) => ({
  [AddEditAppoinmentContent.IsRecurring]: false,
  [AddEditAppoinmentContent.RecurringStartDate]: startDate,
  [AddEditAppoinmentContent.RecurringEndDate]: endDate,
  [AddEditAppoinmentContent.SelectedRecursiveType]: `${AddEditAppoinmentContent.Daily}`,
  [AddEditAppoinmentContent.RecursiveTypeArray]: {
    [AddEditAppoinmentContent.Daily]: {
      [AddEditAppoinmentContent.SelectedDay]: `${AddEditAppoinmentContent.Everyday}`,
      [AddEditAppoinmentContent.SelectedEverDayTextField]: 1,
    },
    [AddEditAppoinmentContent.Weekly]: {
      [AddEditAppoinmentContent.SelectedRepeatEveryWeek]: `${AddEditAppoinmentContent.SelectedRepeatEveryWeek}`,
      [AddEditAppoinmentContent.SelectedRepeatEveryWeekTextField]: 1,
      [AddEditAppoinmentContent.SelectedWeekDays]: [],
    },
    [AddEditAppoinmentContent.Monthly]: {
      [AddEditAppoinmentContent.SelectedMonth]: `${AddEditAppoinmentContent.SelectedRepeatMonth}`,
      [AddEditAppoinmentContent.SelectedEveryMonthDayTextField]: 1,
      [AddEditAppoinmentContent.SelectedEveryMonthTextField]: 1,
      [AddEditAppoinmentContent.SelectedOnMonthTextField]: 1,
      [AddEditAppoinmentContent.SelectedOnMonthDayField]: dayFullForm[1]?.id,
      [AddEditAppoinmentContent.SelectedOnEveryMonthDayTextField]: 1,
    },
    [AddEditAppoinmentContent.Yearly]: {
      [AddEditAppoinmentContent.SelectedYear]: `${AddEditAppoinmentContent.SelectedEveryYear}`,
      [AddEditAppoinmentContent.SelectedEveryYearDayTextField]: 1,
      [AddEditAppoinmentContent.SelectedEveryYearMonthField]:
        monthFullForm[0]?.id,
      [AddEditAppoinmentContent.SelectedOnYearTextField]: 1,
      [AddEditAppoinmentContent.SelectedOnYearDayField]: dayFullForm[1]?.id,
      [AddEditAppoinmentContent.SelectedOnYearMonthField]: monthFullForm[0]?.id,
    },
  },
  [AddEditAppoinmentContent.SelectedRecursiveDateType]: `${AddEditAppoinmentContent.EveryOccurrences}`,
  [AddEditAppoinmentContent.RecursiveDateArray]: {
    [AddEditAppoinmentContent.EveryOccurrences]: {
      [AddEditAppoinmentContent.EveryOccurrencesTextField]: 1,
    },
  },
});
